import React from 'react';
import PropTypes from 'prop-types';
import c from './ContactLink.module.scss';
// import resume from '../../../../Assets/pdf/resume.pdf';

const contactLink = (props) => {
  let linkType = /[\d\w_]+(?=\.(svg|png|jpg))/.exec(props.imgAlt)[0];;
  let url = '';
  let target = '_blank';
  let rel = "noopener noreferrer";

  if(linkType === 'GitHub') {
    url = 'https://github.com/mikec-git';
  } else if(linkType === 'LinkedIn') {
    url = 'https://www.linkedin.com/in/choi-mike/';
  }

  let link = (
    <img
      className={c.ContactLink__Image}
      src={props.imgSrc}
      alt={linkType} />
  );

  return (
    <a
      className={c.ContactLink}
      href={url}
      target={target}
      rel={rel}>
      {link}
      <h5 className={c.ContactLink__Name}>{linkType}</h5>
    </a>
  );
}

contactLink.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  imgAlt: PropTypes.string.isRequired
}

export default contactLink;